import { useDispatch, useSelector } from 'react-redux';
import { selectDelivery, selectDispatchPoint, selectCountry, selectShowInvalids } from '@store/partners-order/selectors';
import { setDispatchPoint } from '@store/partners-order/slice';
import { DispatchPoint } from '@api/types/DispatchPoint';
import { isSpecificDelivery } from '@components/utils';
import { PacketaScript } from '@pages/order/payment-shipping/packeta-script/PacketaScript';
import { DpdScript } from '@pages/order/payment-shipping/dpd-script/DpdScript';
import { PplScript } from '@pages/order/payment-shipping/ppl-script/PplScript';



export const Dispatch = () => {

	const delivery = useSelector(selectDelivery);
	const dispatchPoint = useSelector(selectDispatchPoint);
	const country = useSelector(selectCountry);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateDispatchPoint = (value: DispatchPoint | null) => dispatch(setDispatchPoint(value));

	const isZasilkovna = delivery ? isSpecificDelivery(delivery.id, process.env.ZASILKOVNA_ID) : false;
	const isDpd = delivery ? isSpecificDelivery(delivery.id, process.env.DPD_ID) : false;
	const isPpl = delivery ? isSpecificDelivery(delivery.id, process.env.PPL_ID) : false;

	
	if (!delivery) return (
		<></>
	)

	if (!isZasilkovna && !isDpd && !isPpl) return (
		<></>
	)

	return (
		<div className='dispatch-point-section'>

			{isZasilkovna &&
				<PacketaScript
					dispatchPoint={dispatchPoint}
					showInvalids={showInvalids}
					updateDispatchPoint={updateDispatchPoint}
				/>
			}

			{isDpd &&
				<DpdScript
					dispatchPoint={dispatchPoint}
					showInvalids={showInvalids}
					updateDispatchPoint={updateDispatchPoint}
				/>
			}

			{isPpl &&
				<PplScript
					dispatchPoint={dispatchPoint}
					showInvalids={showInvalids}
					country={country}
					updateDispatchPoint={updateDispatchPoint}
				/>
			}

		</div>
	);
};